import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const NAV_LINKS = [
  { to: '/support-agent',         label: 'Support Tickets',  icon: '🎫', end: true },
  { to: '/support-agent/whatsapp', label: 'WhatsApp Connection', icon: '📱' },
  { to: '/support-agent/db-connectors', label: 'DB Connectors',    icon: '🗄️' },
  { to: '/support-agent/bot-config',    label: 'Bot Config',       icon: '🤖' },
];

export default function SupportAgentSidebar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const isOrgAdmin = user?.role === 'orgadmin';
  const allowedApps = user?.allowedApps || [];
  const hasBotApp = allowedApps.includes('bot');

  return (
    <aside style={s.sidebar}>
      <div style={s.logoArea}>
        <span style={{ fontSize: 22 }}>🎫</span>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={s.logoText}>Support Agent</div>
          <div style={{ fontSize: 9, color: '#475569', letterSpacing: 0.3 }}>by AcceleratorX</div>
          {isOrgAdmin && <div style={s.roleTag}>Org Admin</div>}
        </div>
      </div>

      {/* App switcher — show Bot tab if org also has Bot */}
      <div style={s.appSwitcher}>
        {hasBotApp && (
          <button onClick={() => navigate('/app')} style={s.appTab} title="Switch to Bot">
            🤖 Bot
          </button>
        )}
        <div style={{ ...s.appTab, ...s.appTabActive }}>🎫 Support</div>
      </div>

      <nav style={s.nav}>
        {NAV_LINKS
          .filter(l => l.to !== '/support-agent/db-connectors' || isOrgAdmin)
          .map(l => (
            <NavLink
              key={l.to}
              to={l.to}
              end={!!l.end}
              style={({ isActive }) => ({ ...s.link, ...(isActive ? s.linkActive : {}) })}
            >
              <span style={{ fontSize: 15 }}>{l.icon}</span>
              {l.label}
            </NavLink>
          ))}
      </nav>

      <div style={s.footer}>
        <p style={s.adminName}>{user?.name || user?.email}</p>
        <p style={s.adminEmail}>{user?.email}</p>
        <button style={s.logoutBtn} onClick={logout}>Logout</button>
      </div>
    </aside>
  );
}

const s = {
  sidebar: { width: 220, minHeight: '100vh', background: '#1e293b', borderRight: '1px solid #334155', display: 'flex', flexDirection: 'column', padding: '20px 12px' },
  logoArea: { display: 'flex', alignItems: 'center', gap: 8, padding: '0 4px 20px', borderBottom: '1px solid #334155' },
  logoText: { fontWeight: 700, fontSize: 15, color: '#f1f5f9', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
  roleTag: { fontSize: 10, color: '#22c55e', fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase' },
  appSwitcher: { display: 'flex', gap: 4, padding: '8px 4px', marginBottom: 4, borderBottom: '1px solid #334155' },
  appTab: { flex: 1, textAlign: 'center', padding: '6px 4px', borderRadius: 6, fontSize: 12, fontWeight: 600, cursor: 'pointer', color: '#64748b', textDecoration: 'none', border: '1px solid transparent', background: 'transparent' },
  appTabActive: { background: '#334155', color: '#6366f1', border: '1px solid #6366f140' },
  nav: { display: 'flex', flexDirection: 'column', gap: 2, flex: 1, paddingTop: 8 },
  link: { display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', borderRadius: 8, fontSize: 14, color: '#94a3b8', textDecoration: 'none' },
  linkActive: { background: '#334155', color: '#f1f5f9', fontWeight: 600 },
  footer: { borderTop: '1px solid #334155', paddingTop: 16 },
  adminName: { fontSize: 13, color: '#f1f5f9', padding: '0 8px', marginBottom: 2, fontWeight: 600 },
  adminEmail: { fontSize: 11, color: '#64748b', padding: '0 8px', marginBottom: 8, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  logoutBtn: { width: '100%', padding: '8px', background: 'transparent', border: '1px solid #334155', borderRadius: 8, color: '#94a3b8', cursor: 'pointer', fontSize: 13 },
};
